import PortalIdParser from 'PortalIdParser';
import { FRAMEWORK_TABLE_PARAMS } from '../constants/queryParams';
const getLocationSearch = () => window.location.search;
const getQueryParams = () => {
  const locationSearch = getLocationSearch();
  const urlParams = new URLSearchParams(locationSearch.substring(1));
  const params = Object.fromEntries(urlParams);
  return params;
};
function getFormsV2RoutePrefix() {
  const portalId = PortalIdParser.get();
  return `/forms/${portalId}`;
}
export const getIsExternalEditor = () => {
  const queryParams = getQueryParams();
  return 'isExternalEditor' in queryParams;
};
export const getSearchParamsPrefix = params => params.toString() ? `?${params.toString()}` : '';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/utils/QueryParams.ts#L70
 */
export const getFilteredSearchParams = (currentSearchParams, paramsToRemove) => {
  const searchParams = new URLSearchParams(currentSearchParams);
  paramsToRemove.forEach(param => searchParams.delete(param));
  return getSearchParamsPrefix(searchParams);
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/utils/QueryParams.ts#L60
 */
export const getUpdatedSearchParams = (currentSearchParams, key, value) => {
  const searchParams = new URLSearchParams(currentSearchParams);
  searchParams.set(key, value);
  return getSearchParamsPrefix(searchParams);
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/lib/RouteGenerators.ts#L63
 */
export const getV2EditorRouteQueryString = ({
  redirectUrl
}) => {
  const {
    search
  } = window.location;
  const searchSanitized = getFilteredSearchParams(search, FRAMEWORK_TABLE_PARAMS);
  const queryString = redirectUrl ? getUpdatedSearchParams(searchSanitized, 'redirectUrl', redirectUrl) : searchSanitized;
  return queryString;
};
export const getIsExternalEditorCOS = () => getQueryParams().isExternalEditor === 'cos';

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/lib/RouteGenerators.ts#L81
 */
export const getV2EditorRoute = (guid, step = 'form', redirectUrl = '', options = {}) => {
  const fieldPath = options.field ? `/field/${options.field}` : '';
  const queryString = getV2EditorRouteQueryString({
    redirectUrl
  });
  return `${getFormsV2RoutePrefix()}/editor/${guid}/edit/${step}${fieldPath}${queryString}`;
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/1272b073b4a501e516ed83ba8d9c2fcee528c188/FormsUI/static/js/lib/RouteGenerators.ts#L63
 */
export const getV4EditorRoute = guid => {
  return `${getFormsV2RoutePrefix()}/new-editor/${guid}`;
};
export const getContactListFilterBranch = guid => {
  const filter = {
    filterBranches: [{
      filterBranches: [],
      filterBranchOperator: 'AND',
      filterBranchType: 'AND',
      filters: [{
        filterType: 'FORM_SUBMISSION',
        formId: guid
      }]
    }],
    filterBranchOperator: 'OR',
    filterBranchType: 'OR',
    filters: []
  };
  return JSON.stringify(filter);
};

/**
 * Taken from https://git.hubteam.com/HubSpot/FormsUI/blob/c9f70af2622deb6e252bed10c839934f0dccda5b/FormsUI/static/js/lib/RouteGenerators.ts#L59
 */

export const getCurrentUrl = () => {
  return `${window.location.pathname}${window.location.search}`;
};